import ErrorService from "./../services/error";

export const TEMPLATES_NAMES = ["custom"];

export const PROD_VARS = {
  BASE_URL: "http://www.swiftboard.io/boards/",
};

export const TEST_VARS = {
  BASE_URL: "http://localhost:3000",
};

export const getVar = (varName) => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  )
    return TEST_VARS[varName];
  else return PROD_VARS[varName];
};

export const logError = (error) => {
  ErrorService.createErrorObject(error);
};

export const sortObjectOfObjectByProp = (obj, propName) => {
  let sortedList = [];
  //Sorting by values asc
  sortedList = Object.entries(obj).sort(([key, a], [key2, b]) => {
    console.log("a,b ", a, b);
    if (b[propName] > a[propName]) return 1;
    else if (b[propName] < a[propName]) return -1;
    //if values are same do edition checking if keys are in the right order
    else {
      if (a[propName] > b[propName]) return 1;
      else if (a[propName] < b[propName]) return -1;
      else return 0;
    }
  });

  // return first n values from sortedList
};

export const arrayToObject = (arr) => {
  return arr.reduce(function (acc, [currentKey, currentValue], i) {
    acc[currentKey] = currentValue;
    return acc;
  }, {});
};

export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function getCurrentUserId() {
  return getCookie("user_generated_id");
}

export function getBoardIdFromURL() {
  const params = new URLSearchParams(window.location.search);
  if (params.has("board")) {
    return params.get("board");
  }
  return null;
}

export function shouldCreateNewBoard() {
  const params = new URLSearchParams(window.location.search);
  // to create a new board, we require a url with 3 parameterrs(board=new_board, boardName=XYZ, template=custom)
  if (
    params.has("board") &&
    params.get("board") === "new_board" &&
    params.has("boardName") &&
    params.get("boardName")?.length > 0 &&
    params.get("boardName")?.length <= 30 &&
    params.has("template") &&
    TEMPLATES_NAMES.includes(params.get("template"))
  ) {
    return true;
  }
  return false;
}

export function shouldRecreateDemoBoard() {
  const params = new URLSearchParams(window.location.search);
  // to create a new board, we require a url with 3 parameterrs(board=new_board, boardName=XYZ, template=custom)
  if (
    params.has("resetDemo")  
  ) {
    return true;
  }
  return false;
}

export function getURLParamValue(paramName) {
  const params = new URLSearchParams(window.location.search);
  if (params.has(paramName)) {
    return params.get(paramName);
  }
  return null;
}

export function areArraysEqual(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
}

export function doArrayHaveSameValues(first, second) {
  if (first.length !== second.length) {
    return false;
  }
  for (let i = 0; i < first.length; i++) {
    if (!second.includes(first[i])) {
      return false;
    }
  }
  return true;
}
